// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IProcessClaimDto
 */
export interface IProcessClaimDto {
    /**
     * 
     * @type {string}
     * @memberof IProcessClaimDto
     * @deprecated
     */
    approval_status_code: IProcessClaimDtoApprovalStatusCodeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof IProcessClaimDto
     */
    approval_status_codes?: Array<IProcessClaimDtoApprovalStatusCodesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IProcessClaimDto
     */
    custom_denial_reason?: string;
    /**
     * 
     * @type {number}
     * @memberof IProcessClaimDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IProcessClaimDto
     */
    approval_status_type: IProcessClaimDtoApprovalStatusTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IProcessClaimDto
     */
    is_runout_overridden?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IProcessClaimDto
     */
    remove_deductibles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IProcessClaimDto
     */
    initially_processed_incorrectly?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IProcessClaimDtoApprovalStatusCodeEnum {
    EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES',
    EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES',
    SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD = 'SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD',
    CLAIM_RECEIVED_AFTER_RUNOUT_DATE = 'CLAIM_RECEIVED_AFTER_RUNOUT_DATE',
    CLAIM_SUBMITTED_AFTER_GRACE_PERIOD = 'CLAIM_SUBMITTED_AFTER_GRACE_PERIOD',
    DUPLICATE_CLAIM = 'DUPLICATE_CLAIM',
    PROOF_OF_EXPENSE_NEEDED = 'PROOF_OF_EXPENSE_NEEDED',
    LETTER_OF_MEDICAL_NECESSITY_REQUIRED = 'LETTER_OF_MEDICAL_NECESSITY_REQUIRED',
    DETAILED_RECEIPT_REQUIRED = 'DETAILED_RECEIPT_REQUIRED',
    ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION = 'ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION',
    ADDITIONAL_COMMENTS = 'ADDITIONAL_COMMENTS',
    CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR = 'CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED = 'AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT',
    CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR = 'CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED',
    AUTOMATICALLY_APPROVED_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED = 'AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED',
    AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE',
    AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE',
    CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS = 'CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS',
    CLAIM_SUBMITTED_AFTER_DEADLINE = 'CLAIM_SUBMITTED_AFTER_DEADLINE',
    MEDICAL_EXPENSE_NOT_ELIGIBLE = 'MEDICAL_EXPENSE_NOT_ELIGIBLE',
    ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE = 'ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE',
    AMOUNT_NEEDED = 'AMOUNT_NEEDED',
    DATE_OF_SERVICE_NEEDED = 'DATE_OF_SERVICE_NEEDED',
    DATE_RANGE_OF_CARE_NEEDED = 'DATE_RANGE_OF_CARE_NEEDED',
    DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD = 'DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD',
    DOCUMENT_NOT_READABLE = 'DOCUMENT_NOT_READABLE',
    HANDWRITTEN_RECEIPT_NOT_SUFFICIENT = 'HANDWRITTEN_RECEIPT_NOT_SUFFICIENT',
    MERCHANT_NEEDED = 'MERCHANT_NEEDED',
    SERVICE_DESCRIPTION_NEEDED = 'SERVICE_DESCRIPTION_NEEDED',
    SERVICE_FOR_NEEDED = 'SERVICE_FOR_NEEDED',
    AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE = 'AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE',
    CUSTOM = 'CUSTOM',
    AUTOMATICALLY_APPROVED_BY_SIGIS = 'AUTOMATICALLY_APPROVED_BY_SIGIS',
    AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST = 'AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST',
    APPEAL_NOTE = 'APPEAL_NOTE'
}
/**
* @export
* @enum {string}
*/
export enum IProcessClaimDtoApprovalStatusCodesEnum {
    EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES',
    EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES',
    SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD = 'SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD',
    CLAIM_RECEIVED_AFTER_RUNOUT_DATE = 'CLAIM_RECEIVED_AFTER_RUNOUT_DATE',
    CLAIM_SUBMITTED_AFTER_GRACE_PERIOD = 'CLAIM_SUBMITTED_AFTER_GRACE_PERIOD',
    DUPLICATE_CLAIM = 'DUPLICATE_CLAIM',
    PROOF_OF_EXPENSE_NEEDED = 'PROOF_OF_EXPENSE_NEEDED',
    LETTER_OF_MEDICAL_NECESSITY_REQUIRED = 'LETTER_OF_MEDICAL_NECESSITY_REQUIRED',
    DETAILED_RECEIPT_REQUIRED = 'DETAILED_RECEIPT_REQUIRED',
    ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION = 'ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION',
    ADDITIONAL_COMMENTS = 'ADDITIONAL_COMMENTS',
    CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR = 'CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED = 'AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT',
    CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR = 'CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED',
    AUTOMATICALLY_APPROVED_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED = 'AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED',
    AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE',
    AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE',
    CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS = 'CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS',
    CLAIM_SUBMITTED_AFTER_DEADLINE = 'CLAIM_SUBMITTED_AFTER_DEADLINE',
    MEDICAL_EXPENSE_NOT_ELIGIBLE = 'MEDICAL_EXPENSE_NOT_ELIGIBLE',
    ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE = 'ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE',
    AMOUNT_NEEDED = 'AMOUNT_NEEDED',
    DATE_OF_SERVICE_NEEDED = 'DATE_OF_SERVICE_NEEDED',
    DATE_RANGE_OF_CARE_NEEDED = 'DATE_RANGE_OF_CARE_NEEDED',
    DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD = 'DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD',
    DOCUMENT_NOT_READABLE = 'DOCUMENT_NOT_READABLE',
    HANDWRITTEN_RECEIPT_NOT_SUFFICIENT = 'HANDWRITTEN_RECEIPT_NOT_SUFFICIENT',
    MERCHANT_NEEDED = 'MERCHANT_NEEDED',
    SERVICE_DESCRIPTION_NEEDED = 'SERVICE_DESCRIPTION_NEEDED',
    SERVICE_FOR_NEEDED = 'SERVICE_FOR_NEEDED',
    AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE = 'AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE',
    CUSTOM = 'CUSTOM',
    AUTOMATICALLY_APPROVED_BY_SIGIS = 'AUTOMATICALLY_APPROVED_BY_SIGIS',
    AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST = 'AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST',
    APPEAL_NOTE = 'APPEAL_NOTE'
}
/**
* @export
* @enum {string}
*/
export enum IProcessClaimDtoApprovalStatusTypeEnum {
    PENDING_REVIEW = 'PENDING_REVIEW',
    UNDER_REVIEW = 'UNDER_REVIEW',
    DOCS_NEEDED = 'DOCS_NEEDED',
    INCOMPLETE = 'INCOMPLETE',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    CANCELLED = 'CANCELLED',
    VOIDED = 'VOIDED'
}


/**
 * Check if a given object implements the IProcessClaimDto interface.
 */
export function instanceOfIProcessClaimDto(value: object): value is IProcessClaimDto {
    if (!('approval_status_code' in value) || value['approval_status_code'] === undefined) return false;
    if (!('approval_status_type' in value) || value['approval_status_type'] === undefined) return false;
    return true;
}

export function IProcessClaimDtoFromJSON(json: any): IProcessClaimDto {
    return IProcessClaimDtoFromJSONTyped(json, false);
}

export function IProcessClaimDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessClaimDto {
    if (json == null) {
        return json;
    }
    return {
        
        'approval_status_code': json['approval_status_code'],
        'approval_status_codes': json['approval_status_codes'] == null ? undefined : json['approval_status_codes'],
        'custom_denial_reason': json['custom_denial_reason'] == null ? undefined : json['custom_denial_reason'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'approval_status_type': json['approval_status_type'],
        'is_runout_overridden': json['is_runout_overridden'] == null ? undefined : json['is_runout_overridden'],
        'remove_deductibles': json['remove_deductibles'] == null ? undefined : json['remove_deductibles'],
        'initially_processed_incorrectly': json['initially_processed_incorrectly'] == null ? undefined : json['initially_processed_incorrectly'],
    };
}

export function IProcessClaimDtoToJSON(json: any): IProcessClaimDto {
    return IProcessClaimDtoToJSONTyped(json, false);
}

export function IProcessClaimDtoToJSONTyped(value?: IProcessClaimDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approval_status_code': value['approval_status_code'],
        'approval_status_codes': value['approval_status_codes'],
        'custom_denial_reason': value['custom_denial_reason'],
        'amount': value['amount'],
        'approval_status_type': value['approval_status_type'],
        'is_runout_overridden': value['is_runout_overridden'],
        'remove_deductibles': value['remove_deductibles'],
        'initially_processed_incorrectly': value['initially_processed_incorrectly'],
    };
}

